module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ug0DQT/tc-custom/9781634869294.jpg?1723403764926",
      "alt": "This image is the cover for the book A Classic Blunder, Rainbow Connection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Classic Blunder, Rainbow Connection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sequel to "), _c('i', [_vm._v("Got the Blues")]), _c('br'), _c('br'), _vm._v("Beau Watkins and Vin Reyes have mended their differences, but that doesn't mean everything is back the way it was. When Beau's teenage niece shows up with her son in tow, Beau is thrown unexpectedly into a world of adult responsibilities and adult decisions, all of which could have disastrous consequences. Reconciliation with his family is complicated by an overseas internship with a predatory business woman."), _c('br'), _c('br'), _vm._v("Vin still struggles with his alcoholism, with finding his place in a world after college, and with establishing relationships with his newfound father and sister. The last puzzle piece of Vin's mysterious past clicks into place when he comes face-to-face with his mother's ex-fiancé. His relationship with Beau has never been stronger ... until an unexpected email threatens to topple everything they've build together.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynn Townsend\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0